import { memo } from 'react';

import { useAtomValue } from 'jotai';

import { pathsAtom } from '@store';

import { PATH_KEYS } from '../mappings';
import { Data3D } from '../types';

import { ClubPath } from './ClubPath';
import { HandPath } from './HandPath';

type PathsProps = Pick<Data3D, 'skeleton' | 'keypointIdToName' | 'clubTrack' | 'segmentation'> & {
    frame: number;
    opacity?: number;
};

export function Paths({ frame, skeleton, keypointIdToName, segmentation, clubTrack, opacity }: PathsProps) {
    const paths = useAtomValue(pathsAtom);
    if (paths.length === 0) return null;

    return (
        <>
            {paths.map((path) => {
                if (path === PATH_KEYS.CLUB_PATH) {
                    return (
                        <ClubPath
                            key={path}
                            frame={frame}
                            clubTrack={clubTrack}
                            segmentation={segmentation}
                            opacity={opacity}
                        />
                    );
                }
                if (path === PATH_KEYS.HAND_PATH) {
                    return (
                        <HandPath
                            key={path}
                            frame={frame}
                            skeleton={skeleton}
                            keypointIdToName={keypointIdToName}
                            segmentation={segmentation}
                            opacity={opacity}
                        />
                    );
                }
                return null;
            })}
        </>
    );
}

export const MemoPaths = memo(Paths);
